var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconArrowDiagonalDown48Line = function SvgIconArrowDiagonalDown48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m34.71 17.41-3.4.08.28 11.7-15.76-15.76-2.4 2.4 15.76 15.76-11.7-.28-.08 3.4 14.68.36h.07c.76 0 1.51-.31 2.05-.85.54-.54.87-1.33.85-2.12l-.36-14.68.01-.01Z",
    fill: "current"
  })));
};
export default SvgIconArrowDiagonalDown48Line;